/** @format */

import {styled} from '@mui/material/styles';
import {Box} from '@mui/material';

import {CHARTS_MARGIN_LEFT, CHARTS_MARGIN_RIGHT} from '../../const';

export const Root = styled(Box)(() => ({
  position: 'relative',
}));

export const Hover = styled(Box, {
  shouldForwardProp: prop => prop !== 'hover' && prop !== 'color',
})<{hover: boolean; color: string}>(({hover, color}) => ({
  position: 'absolute',
  zIndex: 0,
  top: 0,
  left: CHARTS_MARGIN_LEFT,
  opacity: hover ? 0.2 : 0,
  transition: '0.2s',
  backgroundColor: color,
  width: `calc(100% - ${CHARTS_MARGIN_LEFT + CHARTS_MARGIN_RIGHT}px)`,
  height: '100%',
}));
